import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import { Section, SectionLabel, SectionTitle, FadeIn } from "@/components/Section";
import { MapPin, Mail, ArrowRight } from "lucide-react";
import { useState } from "react";

const contacts = [
  { icon: MapPin, label: "Registered Office", value: "Majuro, Marshall Islands" },
  { icon: MapPin, label: "Management Office", value: "Houston, Texas, United States" },
  { icon: MapPin, label: "Operations Base", value: "Global" },
  { icon: Mail, label: "Email", value: "operations@velocityoffshore.com" },
];

const enquiryTypes = ["Crew Transfer Services", "Vessel Charter", "Commercial Partnership", "Careers / Crewing", "General Enquiry"];

const inputClass = "w-full px-5 py-4 rounded-xl border border-border bg-card font-body text-sm focus:outline-none focus:ring-2 focus:ring-teal/30 focus:border-teal/50 transition-all";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <Layout>
      <PageHero
        tag="Connect"
        title={<>Let's work <span className="accent-text">together</span></>}
        subtitle="Ready to discuss offshore personnel transportation and Crew Transfer Vessel requirements for your operations?"
      />

      <Section>
        <div className="grid lg:grid-cols-2 gap-20">
          <div>
            <SectionLabel>Office Locations</SectionLabel>
            <SectionTitle>Global presence, <span className="accent-text">local delivery</span></SectionTitle>
            <div className="space-y-6 mt-10">
              {contacts.map((c, i) => (
                <FadeIn key={c.label} delay={i * 0.1}>
                  <div className="flex items-start gap-5 group">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal/10 to-lime/10 flex items-center justify-center flex-shrink-0 group-hover:from-teal/20 group-hover:to-lime/20 transition-colors">
                      <c.icon className="w-5 h-5 text-teal" />
                    </div>
                    <div>
                      <p className="text-text-muted font-body text-xs tracking-[2px] uppercase mb-1">{c.label}</p>
                      <p className="text-navy font-body font-semibold text-lg">{c.value}</p>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>

          <FadeIn delay={0.2}>
            <div className="bg-off-white rounded-2xl p-10 border border-border">
              <h3 className="font-display text-2xl text-navy tracking-tight mb-8">Send an enquiry</h3>
              {submitted ? (
                <div className="text-center py-16">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-teal/20 to-lime/20 flex items-center justify-center mx-auto mb-6">
                    <ArrowRight className="w-7 h-7 text-teal" />
                  </div>
                  <p className="font-display text-xl text-navy mb-2">Thank you!</p>
                  <p className="text-text-light font-body">We'll be in touch shortly.</p>
                </div>
              ) : (
                <form onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }} className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <input type="text" placeholder="Name" required className={inputClass} />
                    <input type="text" placeholder="Company" className={inputClass} />
                  </div>
                  <input type="email" placeholder="Email" required className={inputClass} />
                  <select required className={`${inputClass} text-text-muted`}>
                    <option value="">Enquiry Type</option>
                    {enquiryTypes.map((t) => <option key={t}>{t}</option>)}
                  </select>
                  <textarea placeholder="Message" rows={5} required className={`${inputClass} resize-none`} />
                  <button type="submit" className="group w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-gradient-to-r from-teal to-teal-light text-navy-deep text-[12px] font-bold tracking-[1.5px] uppercase rounded-full hover:shadow-xl hover:shadow-teal/25 transition-all duration-300 font-body">
                    Send Enquiry
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </button>
                </form>
              )}
            </div>
          </FadeIn>
        </div>
      </Section>
    </Layout>
  );
};

export default Contact;
